import React from 'react'
import PropTypes from 'prop-types'
import ModalLayout from './modal_layout'
import Dummy from '../dummy'
import { isPro, me } from '../../initial_state'

class ProUpgradeModal extends React.PureComponent {

  componentDidMount() {
    this.window = window
    if (top != self) top.location.replace(location)
  }
  
  render() {
    const { onClose, isBusiness, noModal, subtitle, shouldDelay, canClose, ctaId } = this.props
    if (isPro) return <div />

    const title = (
      <span className={[_s.d, _s.flexRow, _s.jcCenter, _s.aiCenter].join(' ')}>
        <span className={[_s.d, _s.mr2].join(' ')}>
          Upgrade to Gab
        </span>
        <span className={[_s.bgPro, _s.cBlack, _s.radiusSmall, _s.px5, _s.py5].join(' ')}>PRO</span>
        {
          isBusiness &&
          <span className={[_s.d, _s.ml5].join(' ')}>
            for Business
          </span>
        }
      </span>
    )

    const url = `https://pro.gab.com/upgrade?modal=1${subtitle ? `&message=${subtitle}` : ''}${ctaId ? `&cta=${ctaId}` : ''}${isBusiness ? '&business=true' : ''}`
    const Wrapper = noModal ? Dummy : ModalLayout

    return (
      <Wrapper
        noPadding
        title={title}
        width={1172}
        onClose={onClose}
        shouldDelay={shouldDelay}
        canClose={canClose}
      >
        <div className={[_s.d, _s.w100PC, _s.maxH100VH, _s.minH90VH].join(' ')}>
          <iframe
            className={[_s.d, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.w100PC, _s.h100PC].join(' ')}
            src={url}
          />
        </div>
      </Wrapper>
    )
  }

}

ProUpgradeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isBusiness: PropTypes.bool,
  noModal: PropTypes.bool
}

export default ProUpgradeModal